import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { PageTitle } from '../../_metronic/layout/core'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import ActivatedPageRoute from './ActivatedPageRoute'
import { PAGE_PERMISSION } from '../modules/roles/constant/role-default'
import { Page } from '../modules/roles/models/role-model'
import ActivePageBasedRedirect from './ActivePageBasedRedirect'
import ErrorCenterPage from '../modules/errorcenter/ErrorCenterPage'

type Props = {
  activePages: Page[]
}

const PrivateRoutes: React.FC<Props> = ({ activePages = [] }) => {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))

  const ChartsPage = lazy<React.FC>(() => import('../modules/charts/ChartPage'))
  const UsersPage = lazy<React.FC>(() => import('../modules/users/UserPage'))
  const RolesPage = lazy<React.FC>(() => import('../modules/roles/RolePage'))
  const SettingsPage = lazy<React.FC>(() => import('../modules/settings/SettingsPage'))
  const AuditHistoryPage = lazy<React.FC>(() => import('../modules/audithistory/AuditHistoryPage'))
  const PortalDashboardPage = lazy<React.FC>(() => import('../modules/dashboard/DashboardPage'))
  const DraftInvoicesPage = lazy<React.FC>(() => import('../modules/draftinvoices/DraftInvoicesPage'))
  const MappingRegistryPage = lazy<React.FC>(() => import('../modules/mappingregistry/MappingRegistryPage'))
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>

        <ActivatedPageRoute
          exact
          path="/portal/dashboard"
          component={PortalDashboardPage}
          permission={PAGE_PERMISSION.Dashboard}
          activePages={activePages}
        />

        <ActivatedPageRoute
          exact
          path="/portal/draft-invoices"
          component={DraftInvoicesPage}
          permission={PAGE_PERMISSION.DraftInvoices}
          activePages={activePages}
        />

        <ActivatedPageRoute
          exact
          path="/portal/mapping-registry"
          component={MappingRegistryPage}
          permission={PAGE_PERMISSION.MappingRegistry}
          activePages={activePages}
        />


        <ActivatedPageRoute
          exact
          path="/portal/error-center"
          component={ErrorCenterPage}
          permission={PAGE_PERMISSION.ErrorCenter}
          activePages={activePages}
        />

        <ActivatedPageRoute
          exact
          path="/portal/audit-history"
          component={AuditHistoryPage}
          permission={PAGE_PERMISSION.Admin_Audit}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/dashboard"
          component={DashboardWrapper}
          permission={PAGE_PERMISSION.Dashboard}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/charts"
          component={ChartsPage}
          permission={PAGE_PERMISSION.Charts}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/user"
          component={UsersPage}
          permission={PAGE_PERMISSION.Users}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/role"
          component={RolesPage}
          permission={PAGE_PERMISSION.Roles}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/settings"
          component={SettingsPage}
          permission={PAGE_PERMISSION.Settings}
          activePages={activePages}
        />

        <ActivePageBasedRedirect activePages={activePages} />
        <Redirect to="error/404" />
      </Switch>
    </Suspense>
  )
}

export { PrivateRoutes }
